{
  "overridesEnabledBadgeLabel": "覆寫已開啟",
  "releaseBadgeAlpha": "Alpha",
  "releaseBadgeBeta": "Beta",
  "releaseBadgeDev": "Dev",
  "releaseBadgePoc": "POC"
}
